import _classCallCheck from "/codebuild/output/src198769677/src/codestar-connections.us-west-2.amazonaws.com/git-http/646102706174/us-west-2/a9a51b65-2233-41be-8487-b400c0b14934/amplify-education/web-assessment-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src198769677/src/codestar-connections.us-west-2.amazonaws.com/git-http/646102706174/us-west-2/a9a51b65-2233-41be-8487-b400c0b14934/amplify-education/web-assessment-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var AmpLocale = /*#__PURE__*/function () {
  function AmpLocale() {
    _classCallCheck(this, AmpLocale);
    this.masterDictionary = {};
    this.currentLanaguageDictionary = {};
    this.currentLanaguage = 'EN';
  }
  _createClass(AmpLocale, [{
    key: "setDictionary",
    value: function setDictionary(dictionary) {
      if (!dictionary) throw new Error('AmpLocale. requires a dictionary, dictionary:json');
      this.masterDictionary = dictionary;
    }
  }, {
    key: "addDictionary",
    value: function addDictionary(dictionary) {
      if (!dictionary) throw new Error('AmpLocale. requires a dictionary, dictionary:json');
      this.masterDictionary = this._mergeDictionary(this.masterDictionary, dictionary);
      this.setLanguage(this.currentLanaguage);
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      if (!language) throw new Error('AmpLocale. requires a language, language:string');
      if (!this.masterDictionary[language]) throw new Error("AmpLocale. dictionary does not contain language \"".concat(language, "\""));
      this.currentLanaguage = language;
      this.currentLanaguageDictionary = this.masterDictionary[language];
    }
  }, {
    key: "translate",
    value: function translate(path, values) {
      if (!path) throw new Error('AmpLocale. invalid dictionary path, path:string');
      return this._getText(path, values);
    }
  }, {
    key: "translateForLanguage",
    value: function translateForLanguage(path, language, values) {
      if (!path) throw new Error('AmpLocale. invalid dictionary path, path:string');
      if (!language) throw new Error('AmpLocale. requires a language, language:string');
      var _currentLanaguage = this.currentLanaguage;
      this.setLanguage(language);
      var text = this._getText(path, values);
      this.setLanguage(_currentLanaguage);
      return text;
    }
  }, {
    key: "_getText",
    value: function _getText(path, values) {
      var text = this._resolve(this.currentLanaguageDictionary, path);
      if (values) {
        for (var key in values) {
          var exp = new RegExp('{' + key + '}', 'g');
          text = text.replace(exp, values[key]);
        }
      }
      return text;
    }
  }, {
    key: "_resolve",
    value: function _resolve(dictionary, path) {
      var text = path.split('.').reduce(function (prev, curr) {
        return prev ? prev[curr] : undefined;
      }, dictionary || self);
      return text ? text : path;
    }
  }, {
    key: "_mergeDictionary",
    value: function _mergeDictionary(destination, source) {
      for (var language in source) {
        destination[language] = this._mergeLanguage(destination[language], source[language]);
      }
      return destination;
    }
  }, {
    key: "_mergeLanguage",
    value: function _mergeLanguage(destination, source) {
      for (var entry in source) {
        if (!destination[entry]) {
          destination[entry] = source[entry];
        } else if (typeof destination[entry] === 'object' && typeof source[entry] === 'object') {
          destination[entry] = this._mergeLanguage(destination[entry], source[entry]);
        } else {
          throw new Error("AmpLocale. dictionary already contains \"".concat(entry, "\" key."));
        }
      }
      return destination;
    }
  }]);
  return AmpLocale;
}();
;
export default AmpLocale;